module.exports = __webpack_public_path__ + "static/img/trends4.09670534.webp";